import data from './data.js';
import computed from './computed.js';
import onrender from './onrender.js';
import onteardown from './onteardown.js';
import helpers from './helpers.js';
import methods from './methods.js';
import components from './components.js';
import events from './events.js';
import namespace from './namespace.js';

export default {
	data,
	computed,
	onrender,
	onteardown,
	helpers,
	methods,
	components,
	events,
	namespace
};
